import getDefaultSubscriptionId from './getDefaultSubscriptionId';
import getSubscriptionsByConsentCheckboxes from './getSubscriptionsByConsentCheckboxes';
const updateCommunicationConsentCheckboxes = ({
  legalConsentCopy,
  communicationConsentCheckboxes = []
}) => communicationConsentCheckboxes.map(i => {
  return Object.assign({}, i, {
    label: legalConsentCopy.consentCheckboxes[i.communicationTypeId].content
  });
});
const createCommunicationConsentCheckboxes = ({
  legalConsentCopy,
  subscriptionDefinitions
}) => {
  const filteredSubscriptions = getSubscriptionsByConsentCheckboxes({
    subscriptionDefinitions,
    legalConsentCopy
  });
  const subscriptionId = getDefaultSubscriptionId(filteredSubscriptions);
  return [{
    communicationTypeId: Number(subscriptionId),
    label: legalConsentCopy.consentCheckboxes[subscriptionId].content
  }];
};
const getCommunicationConsentCheckboxes = ({
  legalConsentCopy,
  subscriptionDefinitions,
  communicationConsentCheckboxes = []
}) => {
  if (communicationConsentCheckboxes.length > 0) {
    return updateCommunicationConsentCheckboxes({
      legalConsentCopy,
      communicationConsentCheckboxes
    });
  } else {
    return createCommunicationConsentCheckboxes({
      legalConsentCopy,
      subscriptionDefinitions
    });
  }
};
export default getCommunicationConsentCheckboxes;